export default __webpack_public_path__ + "static/deeksha_smile-bae52effc2f3fc7b943d638538c2138e.png";